import { Pagination, paginationToParams } from '../Pagination';

export interface AffiliateUserFilter {
  pagination: Pagination;
}

export const getDefaultAffiliateUserFilter = (): AffiliateUserFilter => ({
  pagination: {
    page: 0,
    pageSize: 10,
  },
});

export const affiliateUserFilterToQueryParams = (
  filter: AffiliateUserFilter,
) => ({
  ...paginationToParams(filter.pagination),
});
